var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-.015 13.825c-2.342 0-4.271.998-5.822 3.025A8.962 8.962 0 0 0 12 21a8.965 8.965 0 0 0 5.855-2.165c-1.572-2.017-3.517-3.01-5.87-3.01zM12 3a9 9 0 0 0-6.564 15.157c1.725-2.212 3.92-3.332 6.549-3.332 2.638 0 4.848 1.114 6.595 3.314A9 9 0 0 0 12 3zm0 11c-2.018 0-3.025-1.682-3-4.005C9.026 7.637 9.994 6 12 6c2.012 0 3 1.66 3 4s-.988 4-3 4zm0-1c1.321 0 2-1.14 2-3s-.679-3-2-3c-1.314 0-1.979 1.124-2 3.005-.02 1.84.672 2.995 2 2.995z" })
  );
});